import React from 'react'
import NotificationsList from './Notifications/NotificationsList'
import { Redirect } from 'react-router-dom'

import AuthService from '../services/auth.service'

class Notifications extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false
    }
  }

  componentDidMount() {
    if(!AuthService.isAuthorized()) {
      this.setState({redirect: true})
    }
  }

  componentWillUnmount() {
    this.setState({redirect: false})
  }

  render() {
    if(this.state.redirect) {
      return <Redirect to="/logowanie" />
    }

    return (
      <div className="Notifications">
        <NotificationsList />
      </div>
    )
  }
}

export default Notifications